import React, { Component } from "react";
import { toast } from "react-toastify";
// import { uploadXMLFile, pcrResults } from "../../../actions/pcr";
import Dropzone from "react-dropzone";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import { XMLParser } from "fast-xml-parser";
import { pcrResults } from "../../../actions/pcr";
import Loading from "../../../assets/images/loading.gif";
// import xclIcon from "../../../assets/images/xlsIcon.png";
import fileIcon from "../../../assets/images/fileIcon.png";
import dltIcon from "../../../assets/images/DeleteFunction.png";
import DropIcon from "../../../assets/images/overhaul/icons/DropIcon.png";
import PcrUploadXMLAlert from "./PcrUploadXMLAlert";
import "./pcr.css";

// import { s3pcrXML } from "../../../utils/aws";
// import { AUTOMATION_BUCKET } from "../../../utils/Constant";

export default class PcrUploadXML extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {
        countSheets: [],
      },
      displayData: {},
      allGPCOkay: "",
      showResponse: false,
      loading: false,
    };

    // this.apiUploadXMLFile = this.apiUploadXMLFile.bind(this);
  }

  deleteXls = (imgIndex) => {
    const { file } = this.state;
    file.countSheets.splice(imgIndex, 1);
    this.setState({ file });
  };

  handleDrop = (images) => {
    if (images.length === 0) {
      toast.error("Only xml files are supported");
      return;
    }
    if (images.length !== 1) {
      toast.error("Please upload only 1 file");
      return;
    }
    const { file } = this.state;
    setTimeout(() => {
      this.setState({
        file: {
          ...file,
          countSheets: images,
        },
      });
    }, 1000);
  };

  handleSubmit = () => {
    const { file } = this.state;
    this.loading(true);
    if (file.countSheets.length > 0) {
      const blob = new Blob(file.countSheets, { type: "text/xml" });

      const reader = new FileReader();
      reader.onloadend = (event) => {
        // console.log('file content', event.target.result);
        this.parseXMlFile(event.target.result);
      };
      reader.readAsText(blob);
    }
  }

  apiPcrPost = async (jsonObj) => {
    try {
      const response = await pcrResults(jsonObj);
      if (response.success) {
        const data = response.data.result;
        const created_on = response.data.created_on;
        const instrument = response.data.instrument;
        const plate_name = response.data.plate_name;
        const errorData = [];
        const resDataPositive = [];
        const resDataRetest = [];
        let obj = {
          created_on,
          instrument,
          plate_name,
          positive: [],
          retest: [],
          error: [],
        };
        if (data === "All GPC OK") {
          this.setState({ displayData: obj, showResponse: true, allGPCOkay: "All GPC OK" });
        } else if (typeof data === "object" && data.length > 0) {
          data.forEach((item) => {
            if (item.result === "Positive") {
              resDataPositive.push(item);
            } else if (item.result === "Retest") {
              resDataRetest.push(item);
            } else if (item.result !== "Negative") {
              errorData.push(item);
            }
          });

          obj = {
            created_on,
            instrument,
            plate_name,
            positive: resDataPositive,
            retest: resDataRetest,
            error: errorData,
          };

          this.setState({ displayData: obj, showResponse: true });
        }
        this.loading(false);
      } else {
        toast.error("Something went wrong");
        this.loading(false);
      }
    } catch (e) {
      toast.error("Error from apiPcrPost()");
      // eslint-disable-next-line no-console
      console.log(e);
      this.loading(false);
    }
  }

  // handleSubmit = (status) => {
  //   const { file } = this.state;
  //   this.loading();
  //   if (file.countSheets.length > 0) {
  //     file.countSheets.length &&
  //       file.countSheets.forEach((image, indexkey) => {
  //         const data = new FormData();
  //         data.append("file", image, "file.xml");

  //         console.log(this.addXMLtoAWS(file));
  //         // this.apiUploadXMLFile(data);
  //       });
  //   } else {
  //     toast.error("Please select xml file.");
  //   }
  // };

  // addXMLtoAWS = (asset) => {
  //   let fileName = asset.countSheets[0].path;

  //   let blob = new Blob(asset.countSheets, { type: "text/xml" });
  //   let body = new File([blob], fileName, { type: "text/xml" });

  //   console.log(body);
  //   console.log(asset.countSheets[0].path);

  //   return new Promise((resolve, reject) => {
  //     s3pcrXML.upload(
  //       {
  //         Bucket: AUTOMATION_BUCKET,
  //         Key: "media/XML_testing/" + fileName,
  //         Body: body,
  //         ContentType: "text/xml",
  //         ACL: "private",
  //       },
  //       (err, success) => {
  //         if (err) return resolve({ success: false, path: "" });

  //         var location = success.Key;
  //         // console.log(this);
  //         // console.log(location);
  //         this.apiUploadXMLFile(location);
  //         return resolve({ success: true, path: location });
  //       }
  //     );
  //   });
  // }

  // apiUploadXMLFile = async (file) => {
  //   try {
  //     this.loading(true);
  //     const response = await uploadXMLFile(file);
  //     let resData = [];

  //     console.log(response);
  //     if (typeof response.result === "string") {
  //       this.loading(false);
  //       this.setState({ allGPCOkay: response.result, showResponse: true });
  //     } else if (response.result && response.result.length > 0) {
  //       this.loading(false);
  //       response.result.forEach((item) => {
  //         if (item.result === "Positive" || item.result === "Re-test") {
  //           resData.push(item);
  //         }
  //       });
  //       this.setState({ displayData: resData, showResponse: true });
  //     } else {
  //       toast.error("Error uploading XML file, try again!");
  //       this.loading(false);
  //     }
  //   } catch (e) {
  //     toast.error("Something went wrong uploading the file");
  //     this.loading(false);
  //   }
  // };

  toggleModal = () => {
    const { showResponse } = this.state;
    this.setState({
      showResponse: !showResponse,
      displayData: [],
      allGPCOkay: "",
      file: {
        countSheets: [],
      },
    });
  };

  resetState = () => {
    this.setState({
      file: { countSheets: [] },
      displayData: {},
      allGPCOkay: "",
      showResponse: false,
      loading: false,
    });
  };

  parseXMlFile(file) {
    const options = {
      ignoreAttributes: false,
      attributeNamePrefix: "",
      attributesGroupName: "",
      unpairedTags: ["unpaired"],
    };

    const parser = new XMLParser(options);
    const json = parser.parse(file);

    const experimentName = json.Experiment.prop[0]["#text"];
    const createdDate = moment(json.Experiment.prop[1]["#text"]).format("MM/DD/YYYY hh:mm:ss");
    const instrumentName = json.Experiment.run.prop[8]["#text"];

    if (json.Experiment.analyses) {
      const analysesLen = json.Experiment.analyses.analysis.length;
      const resultsArr = [];
      let resultsObjArr = [];
      let output = [];

      // Loop through all analyses
      for (let i = 0; i < analysesLen; i++) {
        const testName = json.Experiment.analyses.analysis[i].prop[0]["#text"].split(" ");
        const index = testName.indexOf("for");
        let parsedTestName = "";

        // Concat the name after the "for" keyword
        for (let j = index + 1; j < testName.length; j++) {
          if (j === testName.length - 1) {
            parsedTestName = parsedTestName.concat(testName[j]);
          } else {
            parsedTestName = parsedTestName.concat(`${testName[j]} `);
          }
        }

        const object = {
          test_name: parsedTestName, well_count: json.Experiment.analyses.analysis[i].AnalysisSamples.AnalysisSample.length, results: [], empty: "",
        };
        resultsArr[i] = object;

        // Loop through each analysis and store genista id, position, cp, tms, and height
        for (let j = 0; j < resultsArr[i].well_count; j++) {
          let genistaID = ""; let position = ""; let
            cp = "";
          let tms = []; let
            heights = [];

          // If the current test contains Tm, we can get height and tms
          if (testName.includes("Tm")) {
            const list = json.Experiment.analyses.analysis[i].AnalysisSamples.AnalysisSample[j].list;

            tms = list[3].item;
            heights = list[1].item;

            const filteredTms = tms.filter((el) => el !== "");

            const filteredHeights = heights.filter((el) => el !== "");

            // Tm will always be after the Abs object gets created, so update that one
            const obj = resultsArr[i - 1].results[j];

            obj.tms = filteredTms;
            obj.heights = filteredHeights;
          } else if (testName.includes("Abs") || testName.includes("Melt")) { // If the current test contains Abs we can get id, position, and cp
            if (!testName.includes("Melt")) {
              const prop = json.Experiment.analyses.analysis[i].AnalysisSamples.AnalysisSample[j].prop;

              for (let k = 0; k < prop.length; k++) {
                // console.log(prop[k]["name"]);
                if (prop[k].name === "name") {
                  genistaID = prop[k]["#text"].split("|")[0];
                } else if (prop[k].name === "Position") {
                  position = prop[k]["#text"];
                } else if (prop[k].name === "CrossingPoint") {
                  cp = prop[k]["#text"];

                  if (cp === undefined) { cp = ""; }
                }
              }

              const testObj = {
                genista_id: genistaID,
                position,
                cp,
                tms,
                heights,
              };

              resultsObjArr[j] = testObj;
            } else {
              resultsObjArr = "Melt found";
            }
          }
        }

        // If melt found adjust the output accordingly. Since melt is always after the Abs, go to the previous entry and remove it if the names match
        if (resultsObjArr === "Melt found") {
          resultsArr[i].empty = "Melt Curve Detected";
          resultsArr[i].results = [];

          if (resultsArr[i - 1].test_name === parsedTestName) { resultsArr[i - 1].results = []; }
        } else {
          resultsArr[i].results = resultsObjArr;
        }

        output = {
          Experiment: experimentName,
          Created: createdDate,
          Instrument: instrumentName,
          Analyses: [
            resultsArr,
          ],
        };

        resultsObjArr = [];
      }

      const finalAnalyses = [];
      const occurances = [];

      // Remove all the entries with empty results and append empty tag when a matching array isn't found
      const len = output.Analyses[0].length;
      for (let i = 0; i < len; i++) {
        // Update occurances of each test
        if (occurances[output.Analyses[0][i].test_name] !== undefined) {
          occurances[output.Analyses[0][i].test_name] += 1;
        } else {
          occurances[output.Analyses[0][i].test_name] = 1;
        }

        // Remove any empty results
        if (output.Analyses[0][i].results.length !== 0 || output.Analyses[0][i].empty === "Melt Curve Detected") {
          finalAnalyses.push(output.Analyses[0][i]);
        }
      }

      output.Analyses = finalAnalyses;

      for (let i = 0; i < output.Analyses.length; i++) {
        // Set anything with an occurance of 1 to No TMS
        if (occurances[output.Analyses[i].test_name] === 1 && output.Analyses[i].empty !== "Melt Curve Detected") {
          output.Analyses[i].empty = "No TMS";
          output.Analyses[i].results = [];
        }
      }

      this.apiPcrPost(output);
    } else {
      toast.error("Invalid xml file uploaded, please verify.");
      this.loading(false);
    }
  }

  loading(value) {
    this.setState({ loading: value });
  }

  render() {
    const {
      showResponse, displayData, allGPCOkay, loading, file,
    } = this.state;
    return (
      <div>
        <Row className="mt-2 ">
          <Col>
            <div className="dropzone-wrapper">
              <div className="dropZoneUploadHeader"> Upload </div>
              {!file.countSheets.length ? (
                <div className="dropzone ">
                  <Dropzone onDrop={this.handleDrop} accept="text/xml" multiple={false}>
                    {({ getRootProps, getInputProps }) => (
                      <section className="dropzone-section">
                        <div {...getRootProps()}> {/* eslint-disable-line */}
                          <input {...getInputProps()} /> {/* eslint-disable-line */}
                          <div className="dropZoneContent">
                            <img
                              className="dropzoneContentIcon"
                              src={DropIcon}
                              alt="DropIcon"
                            />
                            <p className="dropZoneContentText">
                              Select or drag a file
                            </p>
                          </div>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>
              ) : (
                <Row className="pcrImgPreviewSection">
                  {file.countSheets.map((image, imageIndex) => (
                    <Col key={imageIndex} md={2} xs={6} lg={2}>
                      {
                        <div className="pcrImgPreviewContainer">
                          <label className="pcrXMLFileLabel">{image.name}</label>
                          <div className="pcrImgContainer">
                            <div
                              className="pcrImgPreview-top-right"
                              onClick={() => this.deleteXls(imageIndex)}
                            >
                              <img src={dltIcon} width={14} alt="remove" className="pcrImage" />
                            </div>
                            <img
                              className="pcrImgPreview"
                              id="pdf-Preview"
                              alt="pdf-Preview"
                              // height={70}
                              // width={70}
                              src={fileIcon}
                            />
                          </div>
                        </div>
                      }
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Col>
        </Row>
        <div className="uploadTextWarning">Only .xml files are supported</div>
        <div className="text-right">
          <button
            type="button"
            onClick={this.handleSubmit}
            className="submit-btn"
            disabled={!file.countSheets.length}
          >
            Upload
          </button>
        </div>
        {showResponse && (
          <PcrUploadXMLAlert
            displayData={displayData}
            allGPCOkay={allGPCOkay}
            toggleModal={this.toggleModal}
          />
        )}
        {loading && (
          <div className="loadingIndicator">
            <img src={Loading} alt="Loading gif" />
          </div>
        )}
      </div>
    );
  }
}

// Code for parsing the file on the front end
// import moment from "moment";
// import _ from "underscore";
// import XMLParser from "react-xml-parser";

// handleSubmit = async (event) => {
//   event.preventDefault();
//   if (this.App.files.length < 1) {
//     toast.error("Please upload a xml file");
//   } else {
//     const file = this.App.files[0];
//     const reader = new FileReader();
//     reader.readAsText(file);

//     // const response = await uploadXMLFile(reader);
//     // console.log("uploadXMLFile()", response)

//     reader.onloadend = (evt) => {
//       const readerData = evt.target.result;
//       const parser = new DOMParser();
//       const xml = parser.parseFromString(readerData, "text/xml");
//       var newXML = new XMLParser().parseFromString(
//         new XMLSerializer().serializeToString(xml.documentElement)
//       );
//       this.setState({ file: newXML });
//       this.parseXML();
//     };
//   }
// };

// parseXML = () => {
//   const data = this.state.file.children;
//   let experimentName = "";
//   let createdDate = "";
//   let instrumentName = ""; //Temp removed from file [RUN]

//   let results = [];
//   let tmResults = [];

//   data.forEach((element) => {
//     let wellCount = "";
//     let testName = "";
//     let resultName = "";
//     let resultPosition = "";
//     let resultCP = "";

//     if (element.attributes.name === "Created")
//       createdDate = moment(element.value).format("MM/DD/YYYY");
//     if (element.attributes.name === "name") experimentName = element.value;

//     if(element.name === "run") {
//       let instName = false;
//       element.children.forEach((prop) => {
//         if (prop.attributes.name === "InstrumentName") {
//           instName = true;
//         }
//         if(instName) {
//           instrumentName = prop.value;
//           instName = false;
//         }
//       })

//     }

//     if (element.name === "analyses") {
//       let analyses = element.children;
//       analyses.forEach((analysis) => {
//         let abs = false;
//         let tm = false;
//         analysis.children.map((item) => {
//           if (item.attributes.name === "name") {
//             let value = item.value;
//             let type = value.split(" ")[0];
//             if (type === "Abs") {
//               testName = value.substring(value.indexOf("for") + 4);
//               abs = true;
//             }
//             if (type === "Tm") {
//               testName = value.substring(value.indexOf("for") + 4);
//               tm = true;
//             }
//           }
//           if (abs) {
//             if (item.name === "AnalysisSamples") {
//               wellCount = item.children.length;
//               let tempResults = {};
//               let absResults = [];

//               item.children.map((sample) => {
//                 sample.children.map((child) => {
//                   if (child.attributes.name === "name") {
//                     resultName = child.value.split("|")[0];
//                   }
//                   if (child.attributes.name === "Position") {
//                     resultPosition = child.value;
//                   }
//                   if (child.attributes.name === "CrossingPoint") {
//                     resultCP = child.value;
//                   }
//                 });

//                 let result = {
//                   genista_id: resultName,
//                   position: resultPosition,
//                   cp: resultCP,
//                 };
//                 absResults.push(result);
//               });
//               if (absResults.length > 0) {
//                 tempResults = {
//                   test_name: testName,
//                   well_Count: wellCount,
//                   results: absResults,
//                 };
//                 results.push(tempResults);
//               }
//             }
//           } else if (tm) {
//             if (item.name === "AnalysisSamples") {
//               let heights = [];
//               let tms = [];

//               item.children.map((sample) => {
//                 let heightsB = false;
//                 let tmsB = false;
//                 sample.children.map((child) => {
//                   if (child.attributes.name === "Heights") {
//                     heightsB = true;
//                     tmsB = false;
//                   }
//                   if (child.attributes.name === "Tms") {
//                     tmsB = true;
//                     heightsB = false;
//                   }
//                   if (heightsB) {
//                     let tmpArr = [];
//                     child.children.map((item) => {
//                       tmpArr.push(item.value);
//                     });
//                     heights.push(tmpArr);
//                     heightsB = false;
//                   }
//                   if (tmsB) {
//                     let tmpArr = [];
//                     child.children.map((item) => {
//                       tmpArr.push(item.value);
//                     });
//                     tms.push(tmpArr);
//                     tmsB = false;
//                   }
//                 });
//               });

//               let tempTmObj = { test_name: testName, tms: tms, heights: heights };
//               tmResults.push(tempTmObj);
//             }
//           }
//         });
//       });
//     }
//   });

//   results.forEach((element, index) => {
//     let match = 0;
//     // console.log(element.test_name, tmResults[match].test_name)
//     if(element.test_name === tmResults[match].test_name ) {
//       for (let j = 0; j < element.results.length; j++) {
//         element.results[j]["tms"] = tmResults[index].tms[index];
//         element.results[j]["heights"] = tmResults[index].heights[index];
//       }
//       match++;
//     } else {
//       for (let j = 0; j < element.results.length; j++) {
//         element.results[j]["tms"] = [];
//         element.results[j]["heights"] = [];
//       }
//       match--;
//     }
//   });

//   this.apiPostXMLPcr(experimentName,createdDate,results,instrumentName)
// };

// apiPostXMLPcr = async(experimentName,createdDate,results,instrumentName) => {
//   try {
//     const response = await postXMLPcr(
//       experimentName,
//       createdDate,
//       results,
//       instrumentName
//     );
//     let resData = [];
//     if (response.result === "All GPC OK") {
//       console.log("All GPC OKay");
//     } else if(response.result) {
//       if (response.result.length > 0) {
//       response.result.map((item) => {
//         if (item.result === "Positive" || item.result === "Re-test") {
//           resData.push(item);
//         }
//       });
//     }
//     } else {
//       console.log(response);
//     }
//     this.setState({ displayData: resData });
//   } catch (e) {
//     toast.error("Error from apiPostXMLPcr()");
//     console.log(e);
//   }
// }
